import AddUser from "../PureComponents/AddUser";
import React from "react";

const RenderAddUser = ({ popup, hide ,getTeamsData,refreshLocations,refreshTeams ,refreshcategory}) => {
  return (
    <>
      <AddUser popup={popup} hide={hide} getTeamsData={getTeamsData} refreshLocations ={refreshLocations } refreshTeams={refreshTeams}
       refreshcategory={refreshcategory} />
    </>
  );
};

export default RenderAddUser;
